function Iframe({ url }) {
    return (
        <iframe src={url} className="w-[100vw] h-[100vh] relative" />
    )
}

export default Iframe